import {axiosInstance} from "../instance";

const StatisticList = () => {
    return axiosInstance
        .get('/api/statistic');
}

const StatisticSprinklingLastYear = () => {
    return axiosInstance
        .get('/api/statistic/sprinkling-m2/last-year');
}

const StatisticSprinklingByOperator = () => {
    return axiosInstance
        .get('/api/statistic/sprinkling-m2/operators');
}

const StatisticSprinklingByInvestment = () => {
    return axiosInstance
        .get('/api/statistic/sprinkling-m2/investments');
}

const StatisticMachineCondition = () => {
    return axiosInstance
        .get('/api/statistic/ratio/machine-condition');
}

const StatisticUserStatus = () => {
    return axiosInstance
        .get('/api/statistic/ratio/user-status');
}

const StatisticExpenditureLastYear = () => {
    return axiosInstance
        .get('/api/statistic/expenditure/last-year')
}

export {StatisticList, StatisticSprinklingLastYear, StatisticSprinklingByOperator, StatisticSprinklingByInvestment, StatisticMachineCondition, StatisticUserStatus, StatisticExpenditureLastYear};
